export const extractIds = (arr: unknown[]): string[] => {
    let result: any[] = [];
    arr.forEach((i) => {
      if (Array.isArray(i)) {
        result = [...result, ...extractIds(i)]
      } else {
        result.push(i);
      }
    })
    return result;
  }export const extractIds = (arr: unknown[]): string[] => {
    let result: any[] = [];
    arr.forEach((i) => {
      if (Array.isArray(i)) {
        result = [...result, ...extractIds(i)]
      } else {
        result.push(i);
      }
    })
    return result;
  }